export const COMMON_ITEMS_PER_PAGE = 100;
export const USER_ITEMS_PER_LOAD = 60;
export const PAGINATION_FIRST_PAGE_NUMBER = 1;
export const GET_ALL_PARAMS = {page: 0, size: 10000};
export const SCHEDULE_PAGE_SIZE_NAME = 'SCHEDULE_PAGE_SIZE';
export const CONTROL_PAGE_SIZE_NAME = 'CONTROL_PAGE_SIZE_NAME';
export const GENERATE_ZOOM_REGISTRATION_REPORT_MODAL_PAGE_SIZE = 12;
export const FIRST_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 300;

export enum NAVIGATION_CONTROLS {
    Previous = 'Previous',
    Next = 'Next'
}

export const DEFAULT_GET_PAGING_PARAMS = {
    page: 0,
    size: COMMON_ITEMS_PER_PAGE,
    query: '',
    sortField: null,
    sortOrder: null
};
